import { createFileRoute, redirect } from '@tanstack/react-router'

// Visiting an agent's bare chat URL (menu click, "New chat", or the back-compat redirects)
// always starts a fresh conversation, so mint a thread uuid up-front and forward to
// `/agents/$agentId/chat/$uuid`. The thread isn't persisted until the first message is sent,
// so a throwaway uuid (e.g. from prefetch) costs nothing.
export const Route = createFileRoute('/_app/agents/$agentId/chat/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/agents/$agentId/chat/$uuid',
      params: { agentId: params.agentId, uuid: crypto.randomUUID() },
      replace: true,
    })
  },
})
